import {
  existingImageObject,
  newImageId,
} from "../redux/imagePersonalization/tests/constants/image-personalization-actions-constants"
import { initialStateRedux } from "../redux/reducers"

export const userID = 1
export const invalidUserID = 99999999
export const accountID = 123
export const invalidAccountID = 999999999
export const campaignID = 33333333333333
export const invalidCampaignID = 9999999999
export const teamID = 4
export const invalidTeamID = 9999999999
export const leadID = 2
export const invalidLeadID = 9999999999

export const initialState = {
  ...initialStateRedux,
  user: { ...initialStateRedux.user, profile: { ...initialStateRedux.user.profile, id: userID } },
  account: { ...initialStateRedux.account, activeAccountID: accountID },
  campaign: {
    ...initialStateRedux.campaign,
    allCampaigns: {
      campaigns: [
        {
          id: campaignID,
          linkedinAccountId: 1008,
          networkId: 1,
          statusId: 1,
          checkTimestamp: 0,
          name: "jos jedna kampanja",
          lastProcessingTimestamp: 1673860040953,
          onlyPremium: 0,
          onlyDiscoverLeads: 0,
          isFirstConnection: 0,
          getPersonalInfo: 0,
          createdAt: "2023-01-14T22:43:38.000Z",
          updatedAt: "2023-08-06T16:08:15.000Z",
          everyConnectionsSent: true,
          stateId: 1,
          campaignStats: {
            campaignId: campaignID,
            profileViewsMade: 0,
            inmailsSent: 0,
            emailsSent: 0,
            connectionsRequested: 16,
            messagesSent: 0,
            connectionRequestsAccepted: 1,
            connectionsViaEmailRequested: 0,
            connectionReplies: 0,
            responseRate: "0.0000",
            acceptanceRate: "6.2500",
            openRate: "0",
            clickRate: "0",
            totalLeads: 19,
            isActive: true,
            totalFollowCount: 0,
            emailsVerified: 0,
            bounceRate: "0",
            emailsBounced: 0,
            remainingLeads: 0,
          },
          leadSources: [
            {
              id: 7021,
              dashboard: 1,
              generalStatus: "LEAD_DISCOVERY_FINISHED",
              leadSourceType: "BASIC",
              leadSourceUrl:
                "https://www.linkedin.com/search/results/people/?keywords=hannah%20mccollum&network=%5B%22O%22%5D&origin=CLUSTER_EXPANSION&sid=E~A",
              pageNumber: 5,
              csvName: "File.csv",
              lastTimeReused: null,
              autoReuseInterval: null,
              autoReuse: 0,
              scheduledAt: null,
              campaignId: campaignID,
            },
          ],
        },
      ],
      count: 1,
    },
  },
  teamManagement: {
    ...initialStateRedux.teamManagement,
    selectedTeam: {
      teamId: teamID,
      accounts: [
        {
          id: 123,
          permissions: [
            { id: 0, isViewOnly: false },
            { id: 1, isViewOnly: false },
            { id: 2, isViewOnly: false },
            { id: 3, isViewOnly: false },
            { id: 4, isViewOnly: false },
            { id: 5, isViewOnly: false },
            { id: 6, isViewOnly: false },
            { id: 7, isViewOnly: false },
            { id: 8, isViewOnly: false },
            { id: 9, isViewOnly: false },
            { id: 10, isViewOnly: false },
            { id: 11, isViewOnly: false },
            { id: 12, isViewOnly: false },
            { id: 13, isViewOnly: false },
          ],
        },
      ],
    },
    permissions: [
      {
        id: 1,
        name: "Manage webhooks",
        description: "",
        hasViewOnlyOption: false,
      },
      {
        id: 2,
        name: "Manage other messages",
        description: "",
        hasViewOnlyOption: true,
      },
      {
        id: 3,
        name: "Manage global limits",
        description: "",
        hasViewOnlyOption: true,
      },
      {
        id: 4,
        name: "Manage blacklist",
        description: "",
        hasViewOnlyOption: true,
      },
      {
        id: 5,
        name: "Manage chat",
        description: "",
        hasViewOnlyOption: true,
      },
      {
        id: 6,
        name: "Delete seat",
        description: "",
        hasViewOnlyOption: false,
      },
      {
        id: 7,
        name: "Manage campaigns",
        description: "",
        hasViewOnlyOption: true,
      },
      {
        id: 8,
        name: "Cancel subscription",
        description: "",
        hasViewOnlyOption: false,
      },
      {
        id: 9,
        name: "Manage campaign details and reports",
        description: "",
        hasViewOnlyOption: true,
      },
      {
        id: 11,
        name: "Manage seat settings",
        description: "",
        hasViewOnlyOption: false,
      },
      {
        id: 12,
        name: "Open LinkedIn profile",
        description: "",
        hasViewOnlyOption: false,
      },
      {
        id: 13,
        name: "Manage LinkedIn integrations",
        description: "",
        hasViewOnlyOption: true,
      },
      {
        id: 14,
        name: "Manage account health",
        description: "",
        hasViewOnlyOption: true,
      },
      {
        id: 15,
        name: "Manage email settings",
        description: "",
        hasViewOnlyOption: true,
      },
    ],
  },
}

// Account service responses
export const getAccountDataResponse = {
  twoFactorAuthFormInfo: [],
  twoFactorAuthDocumentInfo: {},
  id: "123",
  email: "someEmail@gmail.com",
  lastConnectionUpdate: 1715170758172,
  lastUserConnectionFetch: 1682434939477,
  connectionStatusId: 1,
  withdrawalTimestamp: 1715172207067,
  withdrawalStatusId: 1,
  cooldownConnect: 0,
  cooldownConnectViaEmail: 88888888888888,
  cooldownConnectViaBug: 88888888888888,
  cooldownAccount: 1705594931112,
  cooldownSendMessage: 0,
  cooldownInMail: 0,
  cooldownPaidInMail: null,
  pinFormInfo: null,
  globalSignature: null,
  accountGlobalStatusId: 5,
  linkedinUserId: 39361239,
  teamId: 3,
  accountPaymentStatusId: 1,
  subscriptionId: 5,
  linkedinSubscriptionId: 1,
  cancelAt: null,
  fullName: "Mike Wilson",
  theme: "1",
  createdAt: "2022-02-17T12:57:13.000Z",
  updatedAt: "2024-05-08T12:43:27.000Z",
  getMessagesStatusId: 1,
  lastGetMessagesUpdate: 1715167806150,
  lastListenConnectionTimestamp: 1706796751000,
  linkedinProfileErrors: 0,
  lastFetchMessages: 1714679242123,
  tasksDelay: 0,
  jailPoint: 0,
  isInJail: false,
  planId: 1,
  localStorage:
    '{"voyager-web:connectedTimestamp":"[{\\"_id\\":\\"ACoAADeZefIB70YVboEL0YZ0J4hK2saxoXdcqRo\\",\\"_t\\":1715172185275}]","C_C_M":"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","voyager-web:feedInitialRequestUpdates":"urn:li:activity:7193924753714200579|urn:li:activity:7193917754771476481|urn:li:activity:7193914428575137792","videojs-vhs":"{\\"bandwidth\\":35731750,\\"throughput\\":8813673}","voyager-web:badges":"[{\\"_id\\":\\"ACoAADeZefIB70YVboEL0YZ0J4hK2saxoXdcqRo\\",\\"tab\\":\\"mynetwork\\",\\"count\\":0}]","voyager-web:new-tab-beacon":"[]","voyager-web:enterSend":"false","voyager-web:msg-overlay-state":"[{\\"_id\\":\\"urn:li:fs_miniProfile:ACoAADeZefIB70YVboEL0YZ0J4hK2saxoXdcqRo\\",\\"_listBubble\\":{\\"isMinimized\\":true},\\"_timeLastUpdatedState\\":1715167841412}]"}',
  lastConnectionAcceptedAt: 0,
  pinDocumentInfo: null,
  pinSentAt: null,
  emailCredits: 9999,
  lastEmailSent: null,
  captchaUrl: null,
  pinTimestamp: 1683122053374,
  contactSource: null,
  suspended: false,
  lastGotMessagesAt: 1715167877967,
  isDirtyEmailScheduler: false,
  nextEmailLimitRestart: 1715205600,
  handleOutOfOfficeEmails: true,
  lastAccountGlobalStatusChangedAt: null,
  lastAccountGlobalStatusId: null,
  linkedinUser: {
    education: null,
    experience: null,
    volunteer: null,
    id: 39361239,
    email: null,
    businessEmailFoundByPlatform: null,
    linkedinPersonalEmailFoundByPlatform: null,
    fullName: "Mike Wilson",
    picture: "https://img-store-ln.s3.us-east-2.amazonaws.com/2c9047e0-9dd1-4e22-9750-4ab9ec28a963",
    s3Picture: null,
    occupation: "Project Manager",
    headline: null,
    country: null,
    currentCompanyLogo: null,
    primaryIdentifier: null,
    currentCompany: null,
    yearsInCurrentCompany: null,
    totalCareerPositionsCount: null,
    totalYearsInCareer: null,
    collegeName: null,
    temporaryField: null,
    phone: null,
    twitter: null,
    website: null,
    domain: null,
    connectionDegree: null,
    lastMessage: null,
    messageSeenAt: null,
    messageCreatedAt: null,
    messageDashboardId: null,
    isMessageRead: null,
    activities: null,
    recommendations: null,
    currentLinkedinCompanyId: null,
    createdAt: "2022-02-23T18:28:15.000Z",
    updatedAt: "2022-02-23T18:28:15.000Z",
  },
}

// Getting emailSchedules responses
export const getEmailSchedulesResponse = {
  sumCount: 1,
  count: 1,
  items: [
    {
      id: 170093,
      name: "Default Schedule",
      timezone: "America/New_York",
      teamId: teamID,
      isDefault: true,
      isUsed: true,
      createdAt: "2023-08-08T07:21:26.000Z",
      lastChangeAt: "2024-03-29T11:10:48.000Z",
      user: {
        id: userID,
        fullName: "Kristian Zivkovic",
      },
      intervals: [
        {
          day: 1,
          startTime: "09:00",
          endTime: "17:00",
        },
        {
          day: 2,
          startTime: "09:00",
          endTime: "17:00",
        },
        {
          day: 3,
          startTime: "09:00",
          endTime: "17:00",
        },
        {
          day: 4,
          startTime: "09:00",
          endTime: "17:00",
        },
        {
          day: 5,
          startTime: "09:00",
          endTime: "17:00",
        },
      ],
    },
  ],
}

// Getting emailScheduleTemplates responses
export const getEmailScheduleTemplatesResponse = {
  sumCount: 1,
  count: 1,
  items: [
    {
      id: 26,
      name: "All day, all night",
      timezone: "Europe/Belgrade",
      createdAt: "2023-09-13T09:22:07.000Z",
      teamId: teamID,
      user: {
        id: userID,
        fullName: "Kristian Zivkovic",
      },
      intervals: [
        {
          day: 2,
          startTime: "00:00",
          endTime: "24:00",
        },
        {
          day: 1,
          startTime: "00:00",
          endTime: "24:00",
        },
        {
          day: 3,
          startTime: "00:00",
          endTime: "24:00",
        },
        {
          day: 4,
          startTime: "00:00",
          endTime: "24:00",
        },
        {
          day: 5,
          startTime: "00:00",
          endTime: "24:00",
        },
        {
          day: 6,
          startTime: "00:00",
          endTime: "24:00",
        },
        {
          day: 7,
          startTime: "00:00",
          endTime: "24:00",
        },
      ],
    },
  ],
}

// Getting emailMailboxes resopnse
export const getEmailMailboxeResponse = {
  total: 2,
  active: 2,
  mailboxes: [
    {
      mailboxId: "287858ee-32a4-49a2-bde7-d97bacf0ee6a",
      emailAddress: "someEmail@skylead.io",
      name: "someName",
      integrationType: "gmail",
      status: "ACTIVE",
      isDeleted: false,
      CTDStatus: "NO_CTD_SET",
    },
    {
      mailboxId: "c45c9ba1-c274-4adf-acf2-5f3bc633a663",
      emailAddress: "randomEmail@skylead.io",
      name: "randomName",
      integrationType: "gmail",
      status: "ACTIVE",
      isDeleted: false,
      CTDStatus: "NO_CTD_SET",
    },
  ],
}

// Getting leads by campaign response
export const getLeadsByCampaignResponse = {
  count: 1,
  items: [
    {
      id: 22222414782,
      linkedinUserId: 111322651,
      fullName: "Tech Leadbang",
      firstName: "Tech",
      lastName: "Leadbang",
      occupation: null,
      company: null,
      headline: null,
      connectionDegree: null,
      step: 3,
      leadStatusId: 4,
      active: true,
      firstMessage:
        '<html><head></head><body><div>Hey multiple email here!</div><div><br style="box-sizing: border-box;"></div><div><a href="http://facebook.com" rel="noopener noreferrer" target="_blank">facebook.com</a></div><div><br style="box-sizing: border-box;"></div><div><a href="#" rel="noopener noreferrer" target="_blank">unsubscribe</a></div><div>Signature for kris@skylead.io</div><div><a href="#" rel="noopener noreferrer" target="_blank">unsubscribe</a></div></body></html>',
      receiver: false,
      thread: "CAH5yvwh_figENxaJEo9dPUEMgNGJiOiqOzJzu0r3x0ux+XqhzQ@mail.gmail.com",
      image: null,
      linkedinUrl: "",
      allFieldsData: {
        picture: null,
        fullName: "Tech Leadbang",
        totalCareerPositionsCount: null,
        phone: null,
        occupation: null,
        currentCompany: null,
        email: "tech@leadbang.io",
        country: null,
        collegeName: null,
        yearsInCurrentCompany: null,
        lastName: "Leadbang",
        firstName: "Tech",
      },
      profileIdentifiers: [
        {
          id: 33691373,
          identifier: "tech@leadbang.io",
          identityTypeId: 4,
          linkedinUserId: 111322651,
          createdAt: "2023-09-27T14:45:25.000Z",
          updatedAt: "2023-09-27T14:45:25.000Z",
        },
      ],
      stepChangeTimestamp: 1708619660601,
      businessEmail: null,
      personalEmail: "tech@leadbang.io",
      currentStep: 1,
      nextStep: "Finished",
      nextStepId: 13289637,
      campaign: {
        id: 10424,
        onlyDiscoverLeads: false,
      },
      isOutOfOffice: false,
    },
    {
      id: 22222414920,
      linkedinUserId: 111322789,
      fullName: "Tech Leadbang",
      firstName: "Tech",
      lastName: "Leadbang",
      occupation: null,
      company: null,
      headline: null,
      connectionDegree: null,
      step: 3,
      leadStatusId: 4,
      active: true,
      firstMessage:
        '<html><head></head><body><div>Hey Tech</div><div><br style="box-sizing: border-box;"></div><div><a href="#" rel="noopener noreferrer" target="_blank">unsubscribe</a></div></body></html>',
      receiver: false,
      thread: "0acc3d01-6747-8a50-38e3-2d800dd3f094@leadbang.io",
      image: null,
      linkedinUrl: "",
      allFieldsData: {
        picture: null,
        fullName: "Tech Leadbang",
        totalCareerPositionsCount: null,
        phone: null,
        occupation: null,
        currentCompany: null,
        email: "tech@leadbang.io",
        country: null,
        collegeName: null,
        yearsInCurrentCompany: null,
        lastName: "Leadbang",
        firstName: "Tech",
      },
      profileIdentifiers: [
        {
          id: 33691517,
          identifier: "tech@leadbang.io",
          identityTypeId: 4,
          linkedinUserId: 111322789,
          createdAt: "2023-09-29T10:20:26.000Z",
          updatedAt: "2023-09-29T10:20:26.000Z",
        },
      ],
      stepChangeTimestamp: 1708619519243,
      businessEmail: null,
      personalEmail: "tech@leadbang.io",
      currentStep: 2,
      nextStep: "Finished",
      nextStepId: 13289638,
      campaign: {
        id: 10424,
        onlyDiscoverLeads: false,
      },
      isOutOfOffice: false,
    },
    {
      id: 22222414784,
      linkedinUserId: 111322653,
      fullName: "Tech qualityleads",
      firstName: "Tech",
      lastName: "qualityleads",
      occupation: null,
      company: null,
      headline: null,
      connectionDegree: null,
      step: 3,
      leadStatusId: 4,
      active: true,
      firstMessage: "<html><body> Hey this is a reply<br> </body></html>",
      receiver: true,
      thread: "CAH5yvwiU=aO4ppisLqRUpYvVTx1UXsVk7srSMX+xZ3ck4020EA@mail.gmail.com",
      image: null,
      linkedinUrl: "",
      allFieldsData: {
        picture: null,
        fullName: "Tech qualityleads",
        totalCareerPositionsCount: null,
        phone: null,
        occupation: null,
        currentCompany: null,
        email: "tech@qualityleads.io",
        country: null,
        collegeName: null,
        yearsInCurrentCompany: null,
        lastName: "qualityleads",
        firstName: "Tech",
      },
      profileIdentifiers: [
        {
          id: 33691375,
          identifier: "tech@qualityleads.io",
          identityTypeId: 4,
          linkedinUserId: 111322653,
          createdAt: "2023-09-27T14:45:25.000Z",
          updatedAt: "2023-09-27T14:45:25.000Z",
        },
      ],
      stepChangeTimestamp: 1695831296245,
      businessEmail: null,
      personalEmail: "tech@qualityleads.io",
      currentStep: 3,
      nextStep: "Finished",
      nextStepId: null,
      campaign: {
        id: 10424,
        onlyDiscoverLeads: false,
      },
      isOutOfOffice: false,
    },
    {
      id: 22222414783,
      linkedinUserId: 111322652,
      fullName: "Tech Skylead",
      firstName: "Tech",
      lastName: "Skylead",
      occupation: null,
      company: null,
      headline: null,
      connectionDegree: null,
      step: 0,
      leadStatusId: 1,
      active: true,
      firstMessage:
        "<html><head></head><body><div>This is a third message in a thread!</div></body></html>",
      receiver: false,
      thread: "PR3P190MB0907328E204014872EDA5C02FEC2A@PR3P190MB0907.EURP190.PROD.OUTLOOK.COM",
      image: null,
      linkedinUrl: "",
      allFieldsData: {
        picture: null,
        fullName: "Tech Skylead",
        totalCareerPositionsCount: null,
        phone: null,
        occupation: null,
        currentCompany: null,
        email: "tech@skylead.io",
        country: null,
        collegeName: null,
        yearsInCurrentCompany: null,
        lastName: "Skylead",
        firstName: "Tech",
      },
      profileIdentifiers: [
        {
          id: 33691374,
          identifier: "tech@skylead.io",
          identityTypeId: 4,
          linkedinUserId: 111322652,
          createdAt: "2023-09-27T14:45:25.000Z",
          updatedAt: "2023-09-27T14:45:25.000Z",
        },
      ],
      stepChangeTimestamp: 1695831278854,
      businessEmail: null,
      personalEmail: "tech@skylead.io",
      currentStep: 3,
      nextStep: "Finished",
      nextStepId: null,
      campaign: {
        id: 10424,
        onlyDiscoverLeads: false,
      },
      isOutOfOffice: false,
    },
    {
      id: 22222414781,
      linkedinUserId: 111322650,
      fullName: "Kristian Zivkovic",
      firstName: "Kristian",
      lastName: "Zivkovic",
      occupation: null,
      company: null,
      headline: null,
      connectionDegree: null,
      step: 3,
      leadStatusId: 4,
      active: true,
      image: null,
      linkedinUrl: "",
      allFieldsData: {
        picture: null,
        fullName: "Kristian Zivkovic",
        totalCareerPositionsCount: null,
        phone: null,
        occupation: null,
        currentCompany: null,
        email: "kristiano9611@gmail.com",
        country: null,
        collegeName: null,
        yearsInCurrentCompany: null,
        lastName: "Zivkovic",
        firstName: "Kristian",
      },
      profileIdentifiers: [
        {
          id: 33691372,
          identifier: "kristiano9611@gmail.com",
          identityTypeId: 4,
          linkedinUserId: 111322650,
          createdAt: "2023-09-27T14:45:25.000Z",
          updatedAt: "2023-09-27T14:45:25.000Z",
        },
      ],
      stepChangeTimestamp: 1695831264831,
      businessEmail: null,
      personalEmail: "kristiano9611@gmail.com",
      currentStep: 3,
      nextStep: "Finished",
      nextStepId: null,
      campaign: {
        id: 10424,
        onlyDiscoverLeads: false,
      },
      isOutOfOffice: false,
    },
  ],
  campaignStats: {},
}

// Getting leads by all campaigns response
export const getLeadsByAllCampaignsResponse = {
  count: 1,
  items: [
    { ...getLeadsByCampaignResponse.items[0], id: getLeadsByCampaignResponse.items[0].id + 1 },
  ],
  campaignStats: {},
}

// Getting campaign details response
export const getCampaignDetailsResponse = {
  additionalData: {
    id: 37048,
    campaignId: campaignID,
    personalizedFields: '["email","fullName", {"tag": "myTag"}]',
  },
  stepsTree: null,
  id: campaignID,
  linkedinAccountId: 7,
  networkId: 1,
  statusId: 6,
  statusChangeTimestamp: 1701786406965,
  checkTimestamp: 0,
  name: "Test Sales Nav result",
  connectMessage: null,
  lastProcessingTimestamp: 1718715303731,
  onlyPremium: false,
  onlyOpenInmail: false,
  collectInMailStatus: false,
  onlyDiscoverLeads: false,
  isFirstConnection: false,
  getPersonalInfo: false,
  onlyUniqueLeads: true,
  noPendingConnections: true,
  duplicateLeadsIgnored: 0,
  pendingLeadsIgnored: 0,
  connectLeadsAborted: 0,
  outOfNetworkLeadsIgnored: 0,
  createdAt: "2023-11-16T15:12:39.000Z",
  updatedAt: "2024-06-18T12:55:03.000Z",
  startAt: 0,
  stateId: 1,
  enableClickRate: false,
  enableOpenRate: true,
  includeGloballyTargetedLeads: false,
  globalTargetingIgnoreCount: 0,
  dailyEmailSendingLimit: 30,
  totalEmailsSentToday: 0,
  isDirtyEmailScheduler: false,
  textOnlyEmails: false,
  campaignSteps: [
    {
      nextSteps: [
        {
          previousStepResult: "SUCCESS",
          minRequiredStatusId: 1,
          maxRequiredStatusId: 4,
          action: "follow",
          campaignId: campaignID,
          doAfterPreviousStep: 0,
          id: 13296103,
          step: 2,
          conditions: {},
          ABGroup: null,
          replyToStep: null,
          data: {
            message: "",
            outputs: [
              {
                id: "1",
                color: "#52c462",
                label: "condition-node-yes",
              },
              {
                id: "2",
                color: "#e8285b",
                label: "condition-node-no",
              },
            ],
            tagInfo: [],
            position: {
              x: 480,
              y: 450,
            },
            emailType: "",
            sourceHandle: null,
            allowPaidInMails: false,
            ultraConnectBoost: false,
            inviteMessageOption: "option_a",
            onlyConnectViaEmail: false,
            boostConnectViaEmail: false,
            connectMessageViaEmail: "",
            sentEmailIfNotConnected: false,
          },
        },
      ],
      id: 13296102,
      campaignId: campaignID,
      savedSequenceId: null,
      action: "view",
      step: 1,
      previousStepResult: "SUCCESS",
      data: {
        message: "",
        outputs: [
          {
            id: "1",
            color: "#52c462",
            label: "condition-node-yes",
          },
          {
            id: "2",
            color: "#e8285b",
            label: "condition-node-no",
          },
        ],
        tagInfo: [],
        position: {
          x: 465,
          y: 270,
        },
        emailType: "",
        sourceHandle: null,
        allowPaidInMails: false,
        ultraConnectBoost: false,
        inviteMessageOption: "option_a",
        onlyConnectViaEmail: false,
        boostConnectViaEmail: false,
        connectMessageViaEmail: "",
        sentEmailIfNotConnected: false,
      },
      conditions: {},
      doAfterPreviousStep: 0,
      minRequiredStatusId: 1,
      maxRequiredStatusId: 4,
      ABGroup: null,
      leadExecutedCounts: 0,
      replyToStep: null,
      numberOfLeadsInStep: 0,
    },
    {
      nextSteps: [],
      id: 13296103,
      campaignId: campaignID,
      savedSequenceId: null,
      action: "follow",
      step: 2,
      previousStepResult: "SUCCESS",
      data: {
        message: "",
        outputs: [
          {
            id: "1",
            color: "#52c462",
            label: "condition-node-yes",
          },
          {
            id: "2",
            color: "#e8285b",
            label: "condition-node-no",
          },
        ],
        tagInfo: [],
        position: {
          x: 480,
          y: 450,
        },
        emailType: "",
        sourceHandle: null,
        allowPaidInMails: false,
        ultraConnectBoost: false,
        inviteMessageOption: "option_a",
        onlyConnectViaEmail: false,
        boostConnectViaEmail: false,
        connectMessageViaEmail: "",
        sentEmailIfNotConnected: false,
      },
      conditions: {},
      doAfterPreviousStep: 0,
      minRequiredStatusId: 1,
      maxRequiredStatusId: 4,
      ABGroup: null,
      leadExecutedCounts: 0,
      replyToStep: null,
      numberOfLeadsInStep: 0,
    },
  ],
  campaignStats: {
    id: 11120,
    campaignId: campaignID,
    profileViewsMade: 0,
    connectionsRequested: 0,
    connectionsViaEmailRequested: 0,
    messagesSent: 0,
    inMailsSent: 0,
    connectionRequestsAccepted: 0,
    leadsEngaged: 0,
    leadReplies: 0,
    emailsClicked: 0,
    emailsOpened: 0,
    emailsSent: 0,
    emailsVerified: 0,
    emailsBounced: 0,
    createdAt: "2023-11-16T15:12:39.000Z",
    updatedAt: "2023-11-16T15:12:39.000Z",
    totalFollowCount: 0,
  },
  leadSources: [
    {
      id: 17330,
      campaignId: campaignID,
      dashboard: 2,
      pageNumber: 1,
      leadSourceUrl:
        "https://www.linkedin.com/sales/search/people?companyExcluded=LinkedIn%3A1337%2CMicrosoft%3A1035&companyTimeScope=CURRENT&doFetchHeroCard=false&geoIncluded=103323778&logHistory=true&logId=8582815403&page=1&relationship=S%2CO&rsLogId=144843257&searchSessionId=R9%2Bd9QKnR4qMsXhrTMNJrA%3D%3D&titleIncluded=SDR%2CSales%2520Development%2520Manager%3A1617%2CSales%2520Development%2520Representative%3A9625%2CSales%2520Development%2520Specialist%3A1546&titleTimeScope=CURRENT",
      generalStatus: "LEAD_DISCOVERY_ACTIVE",
      leadSourceType: "SALES_NAVIGATOR",
      createdAt: "2023-11-16T15:14:39.000Z",
      updatedAt: "2024-06-18T12:55:03.000Z",
      csvName: "File.csv",
      lastTimeReused: null,
      autoReuseIntervalMs: 2419200000,
      autoReuse: true,
      scheduledAt: null,
      statusChangeTimestamp: 1718715303738,
      autoReuseInterval: 28,
    },
  ],
  mailboxes: [],
  scheduleId: 202621,
  allMailboxesSelected: false,
}

export const leadImportResponse = {
  result: {
    totalLeads: 1,
    blacklistedItems: 0,
    csvDuplicates: 0,
    teamDuplicates: 1,
    totalDuplicates: 1,
    withoutDuplicatesAndBlacklisted: 0,
    items: ["profileUrl"],
  },
}

export const getPersonalizedImageDataResponse = { ...existingImageObject.data, id: newImageId }
